import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Formatter, StringCompare } from '@stamhoofd/utility';
import { v4 as uuidv4 } from 'uuid';
export class EmergencyContact extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = '';
        this.phone = null;
        this.title = '';
        this.createdAt = new Date();
        /**
         * Stores the timestamp the contact was last edited in the UI (not the same as edited in the database - this is used to find the most correct data in case of duplicates)
         */
        this.updatedAt = null;
    }
    /**
     * Call this to clean up capitals in all the available data
     */
    cleanData() {
        if (StringCompare.isFullCaps(this.name)) {
            this.name = Formatter.capitalizeWords(this.name.toLowerCase());
        }
        if (StringCompare.isFullCaps(this.title)) {
            this.title = this.title.toLowerCase();
        }
        this.name = Formatter.capitalizeFirstLetter(this.name.trim());
        this.title = this.title.trim();
        this.title = Formatter.capitalizeFirstLetter(this.title);
    }
    isEqual(other) {
        this.cleanData();
        other.cleanData();
        return this.name === other.name && this.phone === other.phone && this.title === other.title;
    }
    merge(other) {
        if (other.name.length > 0) {
            this.name = other.name;
        }
        if (other.phone) {
            this.phone = other.phone;
        }
        if (other.title) {
            this.title = other.title;
        }
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], EmergencyContact.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmergencyContact.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], EmergencyContact.prototype, "phone", void 0);
__decorate([
    field({ decoder: StringDecoder })
], EmergencyContact.prototype, "title", void 0);
__decorate([
    field({ decoder: DateDecoder, version: 367 })
], EmergencyContact.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true, version: 367 })
], EmergencyContact.prototype, "updatedAt", void 0);
//# sourceMappingURL=EmergencyContact.js.map